import { Log } from './Log';
import { useParams } from 'react-router-dom';

export const EditQuickLogByCpdId = () => {
  const { cpdId } = useParams<{ cpdId: string }>();
  const decodedCpdId = decodeURIComponent(cpdId);

  return <Log cpdId={decodedCpdId} />;
};
